// extracted by mini-css-extract-plugin
export var teleformContainer = "teleformulaire-module--teleform-container--748ef";
export var teleformFooter = "teleformulaire-module--teleform-footer--d138b";
export var teleformLibre = "teleformulaire-module--teleform-libre--10e3e";
export var teleformLinks = "teleformulaire-module--teleform-links--8b903";
export var teleformLinksItem = "teleformulaire-module--teleform-links-item--39050";
export var teleformLinksItemTitle = "teleformulaire-module--teleform-links-item-title--8144d";
export var teleformLinksList = "teleformulaire-module--teleform-links-list--1b124";
export var teleformLinksTitle = "teleformulaire-module--teleform-links-title--f7b5b";
export var teleformTaxo = "teleformulaire-module--teleform-taxo--b818f";
export var teleformTaxoItem = "teleformulaire-module--teleform-taxo-item--4b2ca";
export var teleformTitle = "teleformulaire-module--teleform-title--cd33e";
export var teleformulaire = "teleformulaire-module--teleformulaire--cb3d0";